import * as actionTypes from './actionTypes';

export const getWorks = (fulltext = "", search = [], limit = 20, offset = 0, sort = {}) => {
    
    const add = {};
    
    if(search.fields && search.fields.length) {
        add.fields = search.fields;
    } else {
        add.fields = [];
    }
    
    add.fields.push({ field: sort.field, type: "ORDER", value: sort.dir});
    
    add.limit = limit;
    add.offset = offset;
    
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });
        window.flow.sdkSearchWerke(fulltext, add).then((res) => {
            dispatch({ type: actionTypes.SDK_WORK_GET_SUCCESS, works: res.objects.asArray(), count: res.count || 0 });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getWork = (id = 1) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });
        window.flow.sdkGetWerk(id).then((res) => {
            dispatch({ type: actionTypes.SDK_WORK_GET_ONE_SUCCESS, work: res/*.children[0]*/, id: id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getWorkByPriref = (id = 1) => {
    const priref = id.replace("sdk", "");
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });
        window.flow.sdkGetWerkByPriref(priref).then((res) => {
            dispatch({ type: actionTypes.SDK_WORK_GET_ONE_SUCCESS, work: res, id: res.project.id, priref: id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getWorkAll = () => {
    return dispatch => {
        dispatch({ type: actionTypes.SDK_WORK_GET_START });

        /* TODO: VARIABLES FOR DISTRIBUTION TREE */
        window.flow.getDistprojectsForDist('sdk_werk', 0).then(res => {
            //dispatch(getDistributionByDistSuccess(res.distproject.elements));
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_WORK_GET_FAIL });
        });
    };
};

export const getObjects = (fulltext = "", search = {}, limit = 20, offset = 0, sort = {}) => {
    const add = {};
    add.limit = limit;
    add.offset = offset;
    
        //console.log(search);

    if(search.fields && search.fields.length) {
        add.fields = search.fields;
    } else {
        add.fields = [];
    }
    
    add.fields.push({ field: sort.field, type: "ORDER", value: sort.dir});
    
    add.kaenguruh = 'no';
    
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_OBJECT_GET_START });
        window.flow.sdkSearchObjects(fulltext, add).then((res) => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_SUCCESS, objects: res.objects.asArray(), objectsObj: res.objects.elements, count: res.count || 0 });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_FAIL });
        });
    };
};

export const getObject = (id = 1) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_OBJECT_GET_START });
        window.flow.sdkGetObject(id).then((res) => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_SUCCESS, objects: [res], objectsObj: { [res.id]: res } });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_FAIL });
        });
    };
};

export const getObjectByPriref = (id = 1) => {
    const priref = id.replace("sdk", "");
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_OBJECT_GET_START });
        window.flow.sdkGetObjectByPriref(priref).then((res) => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_SUCCESS, objects: [res], objectsObj: { [res.id]: res }, priref: id, id: res.id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_OBJECT_GET_FAIL });
        });
    };
};

export const getItemByPriref = (id = 1) => {
    const priref = id.replace("sdk", "");
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_ITEM_GET_START });
        window.flow.sdkGetItemByPriref(priref).then((res) => {
            dispatch({ type: actionTypes.SDK_ITEM_GET_SUCCESS, items: [res], itemsObj: { [res.id]: res }, priref: id, id: res.id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_ITEM_GET_FAIL });
        });
    };
};

//LAMTEST BEGIN
export const getItem = (id = 1) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_ITEM_GET_START });
        window.flow.sdkGetItem(id).then((res) => {
            dispatch({ type: actionTypes.SDK_ITEM_GET_SUCCESS, 
                items: [res], 
                itemsObj: { [res.id]: res }, priref: id, id: res.id });
        }).catch(res => {
            dispatch({ type: actionTypes.SDK_ITEM_GET_FAIL });
        });
    };
};
//LAMTEST END

export const sdkSetLimit = (type, limit) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_LIMIT, section: type, limit: limit });
    }
}

export const sdkSetOffset = (type, offset) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_OFFSET, section: type, offset: offset });
    }
}

export const sdkSetSort = (type, sort) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SET_SORT, section: type, sort: sort });
    }
}

export const sdkSearch = (type, fulltext, search) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_SEARCH_START });
        const fields = [];
        switch(type) {
            case "work":
                Object.keys(search).forEach(key => {
                    if(search[key]) {
                        fields.push({ field: key, type: "CONTAINS", value: search[key]});
                    }
                });
                break;
            case "object":
                Object.keys(search).forEach(key => {
                    if(search[key]) {
                        fields.push({ field: key, type: "CONTAINS", value: search[key]});
                    }
                });
                break;
            case "person":
                
                break;
        }
        
        console.log(fields);
        console.log(fulltext);
        dispatch({ 
            type: actionTypes.SDK_SEARCH_SUCCESS, 
            fulltext: { [type]: fulltext },
            search: { [type]: { search: search, fields: fields } },
            section: type
        });
    };
};

export const sdkOnSelect = (type, obj) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SDK_ON_SELECT, section: type, obj: obj });
    }
}

